import React from 'react';
import {observer} from 'mobx-react';
import {stylesheet} from 'typestyle';
import {Droppable} from 'react-beautiful-dnd';
import {I18n, TProvider} from '../../i18n/i18n';
import LeftSidebarActions from './LeftSidebarActions';
import {BUILDING_BLOCK_TYPE_COLORS, BUILDING_BLOCK_TYPES, PageLayout, ReportEditing, tBuildingBlockTypeName} from '../types/Report';
import {REPORT_DROPABLES} from '../../beautiful-dnd/Droppable';
import {Draggables} from '../../beautiful-dnd/Draggable';
import {LeftSideDragBlock} from './LeftSideBarDragBlock';
import {PageLayoutChanger} from './PageLayoutChanger';
import {DateRangeAdder, DateRangeAdderProps} from './DateRangeAdder';
import {LightGreyColor, Shadow1, WhiteColor} from '../../styles/colors';

interface LeftSideBarProps {
    reportName: string;
    changeReportName: (reportName: string) => void;
    closeEditor: () => void;
    saveReport: () => void;
    reportEditing: ReportEditing;
    closeErrorBox: () => void;
    setPageLayout: (pageLayout: PageLayout) => void;
    dateRangeAdderProps: DateRangeAdderProps;
    togglePreviewMode: () => void;
    previewModeEnabled: boolean;
    isSaving: boolean;
}

@observer
export default class LeftSideBar extends React.Component<LeftSideBarProps> {
    private renderBuildingBlocksHeader() {
        return (
            <div className={blocksCss.barTitleContainer}>
                <div className={blocksCss.barTitle}>
                    <I18n i18nKey="report:buildingBlocks" />
                </div>
            </div>
        );
    }

    private renderReportTitleInput() {
        return (
            <div className={blocksCss.reportTitleContainer}>
                <div className={blocksCss.reportTitle}>
                    <I18n i18nKey="report:reportName" />
                </div>
                <div>
                    <TProvider>
                        {(t) => (
                            <input
                                className={blocksCss.reportTitleInput}
                                value={this.props.reportName}
                                onChange={(e) => this.props.changeReportName(e.currentTarget.value)}
                                placeholder={t('report:reportName')}
                                type="text"
                            />
                        )}
                    </TProvider>
                </div>
            </div>
        );
    }

    public render() {
        return (
            <div className={blocksCss.layoutElementBar}>
                <div className={blocksCss.upperScrollContainer}>
                    {this.renderReportTitleInput()}
                    {this.renderBuildingBlocksHeader()}
                    <Droppable
                        isDropDisabled={true}
                        droppableId={REPORT_DROPABLES.REPORT_TYPE_BUILDING_BLOCKS}
                        type={Draggables.ONLY_DROPPABLE_ON_REPORT_PAPER}>
                        {(provided) => (
                            <div {...provided.droppableProps} ref={provided.innerRef} className={blocksCss.layoutElementList}>
                                {BUILDING_BLOCK_TYPES.map((blockType, index) => (
                                    <LeftSideDragBlock
                                        key={blockType}
                                        index={index}
                                        draggableId={blockType}
                                        dragHandleColor={BUILDING_BLOCK_TYPE_COLORS[blockType]}>
                                        <I18n i18nKey={tBuildingBlockTypeName(blockType)} />
                                    </LeftSideDragBlock>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                    <PageLayoutChanger setPageLayout={this.props.setPageLayout} pageLayout={this.props.reportEditing.layout} />
                    <DateRangeAdder {...this.props.dateRangeAdderProps} />
                </div>
                <LeftSidebarActions
                    isSaving={this.props.isSaving}
                    closeEditor={this.props.closeEditor}
                    saveReport={this.props.saveReport}
                    reportEditing={this.props.reportEditing}
                    closeErrorBox={this.props.closeErrorBox}
                    togglePreviewMode={this.props.togglePreviewMode}
                    previewModeEnabled={this.props.previewModeEnabled}
                />
            </div>
        );
    }
}

const blocksCss = stylesheet({
    reportTitleInput: {
        padding: 10,
        border: '1px solid ' + LightGreyColor,
        borderRadius: 2,
        width: '100%',
    },
    reportTitle: {
        fontSize: 12,
        fontWeight: 'bold',
        marginBottom: 5,
    },
    reportTitleContainer: {
        padding: 15,
    },
    barTitleSwitchText: {
        display: 'inline-block',
        verticalAlign: 'top',
        marginRight: 5,
    },
    barTitleSwitch: {
        flex: 1,
        flexGrow: 1,
        textAlign: 'right',
    },
    barTitle: {
        width: 90,
    },
    barTitleContainer: {
        display: 'flex',
        verticalAlign: 'top',
        padding: '0px 15px 5px 15px',
        textAlign: 'left',
        fontSize: 12,
        fontWeight: 'bold',
    },
    layoutElementList: {
        padding: '0px 15px 15px 15px',
    },
    upperScrollContainer: {
        flexGrow: 1,
        overflow: 'auto',
    },
    layoutElementBar: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        maxWidth: 400,
        backgroundColor: WhiteColor,
        zIndex: 4,
        width: '100%',
        boxShadow: Shadow1,
    },
});



// WEBPACK FOOTER //
// ./src/report/views/LeftSideBar.tsx